import { ModalRoot, Modal, ModalContent, ModalFooter, Button } from '@pella/sash-framework';

import * as classes from './LinkedActionConfirmModal.module.css';

/**
 * LinkedActionConfirmModal Atom Component
 * Asks the user whether to generate a request from the completed request's linked action.
 * @param {Local.LinkedActionConfirmModalProps} props - Component props
 */
export const LinkedActionConfirmModal = ({ isOpen, description, onDecline, onConfirm }) => (
  <ModalRoot open={isOpen}>
    <Modal className={classes.container} showClose={false}>
      <ModalContent>
        This request is linked to <i>{description}</i>. Do you want to generate a request from this linked action?
      </ModalContent>
      <ModalFooter className={classes.modalFooter}>
        <Button color='secondary' onClick={onDecline}>
          NO
        </Button>
        <Button color='primary' onClick={onConfirm}>
          YES
        </Button>
      </ModalFooter>
    </Modal>
  </ModalRoot>
);
